import React from "react";
import CustomOffCanvas from "./CustomOffCanvas"; // ⬅️ tu nuevo componente
import FilterTitle from "./filter/FilterTitle";

const LabelValue = ({ label, value }) => (
    <div className="mb-2">
        <strong>{label}:</strong> {value || "—"}
    </div>
);

const ArrayField = ({ label, values }) => (
    <div className="mb-2">
        <strong>{label}:</strong> {(values || []).length > 0 ? values.join(", ") : "—"}
    </div>
);

const HealthCenterDetails = ({ center, onClose, show }) => {
    if (!center) return null;

    return (
        <CustomOffCanvas
            id="detailsOffCanvas"
            title={`Details of ${center.name}`}
            isOpen={show}     // 👈 nuevo prop para controlar visibilidad
            onClose={onClose} // 👈 cerrar manualmente
            width="custom-offcanvas-wide"
        >
            <FilterTitle title="Basic Information" />
            <LabelValue label="Name" value={center.name} />
            <LabelValue label="Type" value={center.type} />
            <LabelValue label="Phone" value={center.phone} />
            <LabelValue label="Email" value={center.email} />
            <LabelValue label="Website" value={center.website} />
            <LabelValue label="Address" value={center.address} />
            <LabelValue label="City" value={center.city} />
            <LabelValue label="State" value={center.state} />
            <LabelValue label="Zipcode" value={center.zipcode} />
            <LabelValue label="CIF" value={center.cif} />

            <FilterTitle title="Advanced Information" />
            <ArrayField label="Services" values={center.services} />
            <ArrayField label="Departments" values={center.departments} />
            <ArrayField label="Facilities" values={center.facilities} />
            <ArrayField label="Equipments" values={center.equipments} />
            <LabelValue label="About" value={center.about} />

            <FilterTitle title="Accessibility" />
            <LabelValue label="Wheelchair Access" value={center.wheelChairAccess ? "Yes" : "No"} />
            <LabelValue label="Parking Access" value={center.hasParking ? "Yes" : "No"} />
            <LabelValue label="Sign Language Support" value={center.signLanguageSupport} />
            <ArrayField label="Accessibility" values={center.accessibility} />

            <FilterTitle title="Others" />
            <ArrayField label="Languages" values={center.languages} />
            <ArrayField label="Payment Methods" values={center.paymentMethod} />
            <ArrayField label="Insurance" values={center.insurance} />
            <LabelValue label="Rating" value={center.rating} />
        </CustomOffCanvas>
    );
};

export default HealthCenterDetails;
